import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token';

export function getCookies(key) {
  return Cookies.get(key)
}
export function setCookies(key,value) {
  return Cookies.set(key,value)
}
export function removeCookies(key) {
  return Cookies.remove(key)
}

export function clearCookies() {
  let keys = document.cookie.match(/[^ =;]+(?==)/g)
  if (keys) {
    for (let i = keys.length; i--;) {
      document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString() // 清除当前域名下的,例如：m.ratingdog.cn
      document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString() // 清除当前域名下的，例如 .m.ratingdog.cn
      document.cookie = keys[i] + '=0;path=/;domain=ratingdog.cn;expires=' + new Date(0).toUTCString() // 清除一级域名下的或指定的，例如 .ratingdog.cn
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/auth.js